import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reservations-skeleton" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "mt-5" }

import CurrentBookingsSkeleton from './CurrentBookingsSkeleton.vue'
  import PastBookingsSkeleton from './PastBookingsSkeleton.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationsSkeleton',
  setup(__props) {

  // Import the Skeleton Components
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-skeleton d-flex justify-content-between align-items-center my-4" }, [
      _createElementVNode("div", { class: "shimmer skeleton-title" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CurrentBookingsSkeleton)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "shimmer skeleton-title mb-4" }, null, -1)),
      _createVNode(PastBookingsSkeleton)
    ])
  ]))
}
}

})